
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[_network]/pools/[_id]",
      function () {
        return require("private-next-pages/[_network]/pools/[_id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[_network]/pools/[_id]"])
      });
    }
  